// extracted by mini-css-extract-plugin
export default {"qrcode__container":"o0O8H","qrcode__icon":"FgooM","qrcode__image":"rrzXi"};